import { useTheme } from "@mui/material/styles";
import logo from "./../assets/images/logo.png";
import logoW from "./../assets/images/logo_light.png";

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ light }) => {
  const theme = useTheme();

  return <img src={light ? logoW : logo} alt="20" width={light ? 200 : "250"} />;
};

export default Logo;
